import * as pdfMake from 'pdfmake/build/pdfmake';
import { TDocumentDefinitions } from 'pdfmake/interfaces';
import logoImg from '../../../assets/logo-black.png';
import { IOperationLog } from '../hooks/rfid';

const docDefinition = (
  img: string,
  data: IOperationLog[]
): TDocumentDefinitions => ({
  info: {
    title: 'Conferência Portal RFID',
    author: '4Innovation',
    creationDate: new Date(),
  },
  pageOrientation: 'landscape',
  content: [
    {
      style: 'header',
      table: {
        widths: ['auto', '*'],
        body: [
          [
            {
              image: img,
              width: 150,
              height: 50,
              border: [false, false, false, false],
            },
            {
              text: 'Conferência Portal RFID',
              bold: true,
              alignment: 'right',
              fontSize: 14,
              margin: [0, 17, 0, 0],
              border: [false, false, false, false],
            },
          ],
        ],
        layout: 'noBorders',
      },
    },

    {
      margin: [0, 10, 0, 0],
      table: {
        widths: [50, 150, 150, '*', 'auto', 'auto'],
        body: [
          [
            {
              text: 'Data',
              alignment: 'center',
              fontSize: 10,
              bold: true,
              fillColor: '#CCC',
            },
            {
              text: 'Códigos Lidos',
              alignment: 'center',
              fontSize: 10,
              bold: true,
              fillColor: '#CCC',
            },
            {
              text: 'Códigos Traduzidos',
              alignment: 'center',
              fontSize: 10,
              bold: true,
              fillColor: '#CCC',
            },
            {
              text: 'Motorista',
              alignment: 'center',
              fontSize: 10,
              bold: true,
              fillColor: '#CCC',
            },
            {
              text: 'Carga OK',
              alignment: 'center',
              fontSize: 10,
              bold: true,
              fillColor: '#CCC',
            },
            {
              text: 'Informação',
              alignment: 'center',
              fontSize: 10,
              bold: true,
              fillColor: '#CCC',
            },
          ],
          ...generateTable(data),
        ],
      },
    },
  ],
  styles: {
    header: {
      fontSize: 32,
      bold: true,
      alignment: 'right',
      italics: true,
    },
  },
});

function generateTable(data: IOperationLog[]) {
  const rows = data.map((rfid) => {
    return [
      {
        text: rfid.createdAt,
        alignment: 'center',
        fontSize: 8,
      },
      {
        text: rfid.codesRead,
        alignment: 'center',
        fontSize: 7,
      },
      {
        text: rfid.codesTranslated,
        alignment: 'center',
        fontSize: 8,
      },
      {
        text: rfid.driverName,
        alignment: 'center',
        fontSize: 8,
      },
      {
        text: rfid.correctConference,
        alignment: 'center',
        fontSize: 8,
      },
      {
        text: rfid.inconsistency,
        alignment: 'center',
        fontSize: 8,
      },
    ];
  });

  return rows;
}

export async function generateRfidReportPDF(data: IOperationLog[]) {
  const image = document.createElement('img');

  image.src = logoImg;

  const imgBlob = await fetch(image.src).then((res) => res.blob());

  const base64: string | ArrayBuffer | null = await new Promise(
    (resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
      reader.readAsDataURL(imgBlob);
    }
  );

  if (typeof base64 === 'string') {
    pdfMake.createPdf(docDefinition(base64, data)).open();
  }
}
